import { render } from "./TourView.vue?vue&type=template&id=7995a87a"
import script from "./TourView.vue?vue&type=script&lang=js"
export * from "./TourView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__